module.exports = __webpack_public_path__ + "static/media/ELS200NG05.6d3505fe.png";